import { render } from "./UpsellDescription.vue?vue&type=template&id=e4c46e5a"
import script from "./UpsellDescription.vue?vue&type=script&lang=js"
export * from "./UpsellDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__